import React, { Component } from 'react';
import { inject, observer, Provider } from 'mobx-react';
import { intercept } from 'mobx';
import Cookies from 'js-cookie';
import { withRouter } from 'react-router';
import WakeLock from 'react-wakelock';
import IdleTimer from 'react-idle-timer';
import ReactGA from 'react-ga';

import '../shared/_sass-globals/style.scss';
import './app.scss';

let classNames = require('classnames');

@inject('appStore', 'routerStore')
@withRouter
@observer
export class App extends Component {

    componentWillMount() {
        const { appStore } = this.props,
            debug = process.env.NODE_ENV !== 'production';

        if (debug) {
            Cookies.set('forceCollection', 6);
        }

        let forceCollection = Cookies.get('forceCollection');

        if (typeof forceCollection !== 'undefined') {
            appStore.expCollectionID = forceCollection;
        }

        appStore.initializeSettings().then(() => {
            appStore.initializeCollections();
        });

        // manage analytics events
        this.disposeSettings = intercept(appStore, 'settings', (change) => {
            if (change.newValue.GACode) {
                ReactGA.initialize(change.newValue.GACode, {debug: debug});
                let url = window.location.pathname + window.location.search + window.location.hash;
                ReactGA.pageview(url);
            }
            return change;
        });
    }

    getWakelock() {
        const { appStore } = this.props;
        if (appStore.settings && appStore.settings.Wakelock) {
            return <WakeLock />;
        }
    }

    onIdle() {
        const { appStore, routerStore } = this.props,
            zoomState = {
                left: '-100%',
                top: '-100%',
                scaleX: 1,
                scaleY: 1,
                open: false
            };
        appStore.zoomState = zoomState;
        appStore.carouselOpen = false;

        let elements = document.getElementsByClassName('collection');
        if (elements.length) {
            elements[0].scrollLeft = 0;
        }

        if (appStore.collection) {
            routerStore.history.push(appStore.collection.Link);
            // console.log('Idle', appStore.collection.Link);
        } else {
            routerStore.history.push('/');
            // console.log('Idle', '/');
        }
    }

    onActive() {
        // console.log('active');
    }

    getIdleTimer() {
        const { appStore } = this.props;
        if (appStore.settings && appStore.settings.IdleTime > 0) {
            let timeout = parseInt(appStore.settings.IdleTime, 10) * 1000;
            // console.log('timeout in ms', timeout);
            return <IdleTimer
                activeAction={() => this.onActive()}
                idleAction={() => this.onIdle()}
                timeout={timeout}
            />;
        }
    }

    openAbout() {
        const { appStore, routerStore } = this.props;
        appStore.aboutOpen = true;
        if (appStore.collection) {
            routerStore.history.push(appStore.collection.Link + '/about');
        }
    }

    getFooter() {
        const { appStore } = this.props,
            footerClasses = classNames({
                'footer': true,
                'footer-open': !appStore.aboutOpen
            }),
            logoClasses = classNames({
                'footer-logo': true,
                'footer-logo--white': appStore.collection && appStore.collection.LogoColor === 'white'
            }),
            aboutLinkClasses = classNames({
                'footer-aboutlink': true,
                'footer-aboutlink--white': appStore.collection && appStore.collection.LogoColor === 'white'
            });

        return <div className={footerClasses}>
            {appStore.settings && !appStore.settings.IsInternal && <div className={logoClasses} />}
            {appStore.collection && appStore.collection.EnableAboutContent &&
                <button className={aboutLinkClasses} onClick={e => this.openAbout(e)}>{appStore.collection.AboutButtonText}</button>}
        </div>;
    }

    render() {
        const { appStore } = this.props;

        return <div className='app'>
            <Provider appStore={appStore}>
                <div>
                    {this.getFooter()}
                    {this.getWakelock()}
                    {this.getIdleTimer()}
                    {this.props.children}
                </div>
            </Provider>
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_app/app.js